import React, { Suspense } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Skeleton } from 'antd'
import { getFirstRoutePath } from '../utils/util'
import ManageAside from './ManageAside'

type Props = {
  routes: Routes
}

const ManageLayout: React.FC<Props> = ({ routes, ...rest }) => {
  const firstPath = getFirstRoutePath(routes)
  const redirectPath = !firstPath || firstPath === '*' ? '/notFound' : firstPath
  const fromPath = /(\/[A-z]+)/.exec(location.hash)?.[0]
  const renderRoutes = (routes: Routes): React.ReactNode => {
    if (!routes?.length) {
      return null
    }
    return routes.map(route =>
      route.component ? (
        <Route exact={!route.routes} key={route.path} path={route.path}>
          {
            <route.component {...rest} routes={route.routes}>
              {route.routes && renderRoutes(route.routes)}
            </route.component>
          }
        </Route>
      ) : (
        route.routes && renderRoutes(route.routes)
      )
    )
  }

  return (
    <div className="startStart" style={{ overflow: 'hidden', height: '100%' }}>
      <div className="aside">
        <ManageAside routes={routes}></ManageAside>
      </div>
      <div className="main flex1">
        <div className="main-container">
          <Suspense fallback={<Skeleton active></Skeleton>}>
            <Switch>
              <Redirect exact from={fromPath} to={redirectPath} />
              {renderRoutes(routes)}
            </Switch>
          </Suspense>
        </div>
      </div>
    </div>
  )
}

export default ManageLayout
